<template>
    <div class="card">
        <div class="card-header text-center">
            <span>
                {{ participant.name }} - {{ survey }}
            </span>
        </div><!-- .card-header -->

        <div class="card-body d-flex align-items-center">

            <div class="row">
                <div class="col">

                    <div v-if="Object.keys(error).length" class="alert alert-danger" role="alert">
                        {{ error.message }}
                    </div>

                    <page v-if="isLoaded"></page>
                    <div v-else>Loading...</div>

                </div>
            </div>

        </div><!-- .card-body -->

        <div class="card-footer d-flex justify-content-between">
            <button id="previous_button" class="btn btn-primary" @click="previousPage()" :disabled="currentIdx === 0">
                <font-awesome-icon icon="fa-solid fa-caret-left" class="me-2" /> {{ buttonPrevious[participant.language] }}
            </button>
            <button id="next_button" v-if="currentIdx < (pages.length - 1)" class="btn btn-primary" :disabled="nextButtonDisabled" @click="nextPage()">
                {{ buttonNext[participant.language] }} <font-awesome-icon icon="fa-solid fa-caret-right" class="ms-2" />
            </button>
            <button v-else class="btn btn-info text-white" @click="finalizeSurvey()">Finalize</button>
        </div><!-- .card-footer -->
    </div><!-- .card -->
</template>


<style scoped>
.card {
    font-size: 1.2rem;
}
.card-body {
    min-height: 225px;
}
</style>    


<script setup>
    import { ref, onMounted, onUnmounted } from 'vue'
    import { storeToRefs } from 'pinia'
    import { useSurveysStore } from '../../stores/surveys'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import Page from './Page.vue'
    import bootbox from 'bootbox'

    const { setParticipant, setSurvey, loadPages, loadResponse, nextPage, previousPage, finalizeSurvey } = useSurveysStore()
    const { survey, pages, participant, currentIdx, error, nextButtonDisabled } = storeToRefs(useSurveysStore())
    const props = defineProps(['surveyName', 'participant', 'surveyPages', 'response'])

    const isLoaded = ref(false)
    const initializeSurvey = async () => {
        // order important
        loadPages(props.surveyPages)
        setSurvey(props.surveyName)
        await loadResponse(props.response, props.participant)
        setParticipant(props.participant)
        isLoaded.value = true
    }

    const buttonPrevious = JSON.parse('{"english": "Previous", "spanish": "Previo", "french": "Précédente"}')
    const buttonNext = JSON.parse('{"english": "Next", "spanish": "Siguiente", "french": "Suivante"}')

    const showSessionExpiredAlert = () => {
        bootbox.alert({
            message: "Your session has expired. The page will refresh and return you to the beginning of the survey.",
            centerVertical: true,
            callback: function() {
                window.location.reload()
            }
        })
    }

    onMounted(() => {
        initializeSurvey()

        // catch client/server errors
        axios.interceptors.response.use(response => {
            return response;
        }, error => {
            // 419 is a non-standard laravel code for CSRF token mismatch
            if (error.response && (error.response.status == 401 || error.response.status == 419)) {
                showSessionExpiredAlert()
            } else if (error.response && (error.response.status >= 400 && error.response.status < 500)) {
                bootbox.alert("A client-side error occurred. Please let your contact know. Thank you!");
            } else if (error.response && error.response.status >= 500) {
                bootbox.alert("A server-side error occurred. Please let your contact know. Thank you!");
            }
            return Promise.reject(error);
        });
    })
</script>